<template>
  <a-card :bordered="false" :loading="pageLoading" v-if="pageLoading">Loading ...</a-card>
  <a-row :gutter="8" v-else>
    <loading v-if="anggaran.loadingtree" />
    <a-col :xs="{ span: 24 }">
      <a-form :form="form">
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-item label="Description">
              <a-input v-decorator="['deskripsi', { rules: [{ required: true }] }]"></a-input>
            </a-form-item>

            <a-form-item label="Jenis Anggaran">
              <a-select
                showSearch
                :not-found-content="null"
                option-filter-prop="children"
                v-decorator="[
              'jenis_anggaran',
              {
                rules: [{ required: true }],
                initialValue: informasi.jenis_anggaran
              },
            ]"
                @change="handleJenisAnggaran"
                
              >
                <a-select-option v-for="item in getJenisAnggaran" :key="item.value">
                  {{
                  item.text
                  }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="Cost Center">
              <!-- <a-row :gutter="16">
              <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">-->
              <a-select
                
                showSearch
                v-decorator="[
                      'cost_center',
                      {
                        rules: [{ required: true }],
                        initialValue: informasi.cost_center
                      },
                    ]"
                @change="handleCost"
              >
                <a-select-option v-for="item in costCenter" :key="item.value">
                  {{
                  item.text}} ({{item.nama_pekerjaan ? item.nama_pekerjaan : '-'}})
                </a-select-option>
              </a-select>
              <!-- </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                <a-button type="primary"
                  :disabled="!modalanggaran.enabled"
                  @click="showChoiceModal"
                  :loading="modalanggaran.loadingButton"
                  size="small"
                  >
                  Select Financing Code
                </a-button>
              </a-col>
              </a-row>-->
            </a-form-item>
            <a-form-item label="Peruntukan">
              <a-select
                
                showSearch
                v-decorator="[
              'peruntukan',
              {
                rules: [{ required: true }],
                initialValue: informasi.peruntukan
              },
            ]"
                @change="handlePeruntukan"
                optionFilterProp="children"
                :filterOption="filterOption"
              >
                <a-select-option v-for="item in peruntukan" :key="item.value">
                  {{
                  item.text
                  }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <!-- <a-form-item label="Sub Peruntukan">
          <a-select
            :disabled="subPeruntukan.length == 0"
            showSearch
            v-decorator="[
              'sub_peruntukan',
              {
                rules: [{ required: true }],
              },
            ]"
            @change="handleSubPeruntukan"
            optionFilterProp="children"
            :filterOption="filterOption"
          >
            <a-select-option v-for="item in subPeruntukan" :key="item.value">{{
              item.text
            }}</a-select-option>
          </a-select>
            </a-form-item>-->
            <a-form-item label="Kode Anggaran">
              <!-- <a-select
            :disabled="anggaran.length == 0"
            showSearch
            @change="handleCodeAnggarn"
            v-decorator="[
              'kode_anggaran',
              {
                rules: [{ required: true }],
              },
            ]"
            optionFilterProp="children"
            :filterOption="filterOption"
          >
            <a-select-option v-for="item in anggaran" :key="item.value">{{
              item.text
            }}</a-select-option>
              </a-select>-->

              <a-tree-select
                v-decorator="['kode_anggaran', {rules: [{required: true}]}]"
                show-search
                style="width: 100%"
                @select="handlechoiceCost"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="anggaran.tree"
                treeNodeFilterProp="children"
                :filterTreeNode="filterTreeNode"
                placeholder="Please select"
                allow-clear
                :treeExpandedKeys="treeExpandedKeys"
                :disabled="anggaran.loadingtree || anggaran.tree==undefined || anggaran.tree.length==0"
              >
                <span slot="title" slot-scope="item">
                  <table style="width:100%">
                    <tr>
                      <td>
                        <span>{{item.texttitle}} - {{item.kode_anggaran}}</span>
                      </td>
                      <td>
                        <span style="float:right">{{formatRupiah(parseFloat(item.rekap))}}</span>
                      </td>
                    </tr>
                  </table>
                </span>
              </a-tree-select>
            </a-form-item>

            <a-form-item label="Prospect No" v-if="selectedCostCenter=='07'">
              <a-select
                showSearch
                :allowClear="(getTlc_CEO==end_user_klaim ? true : false)"
                :not-found-content="null"
                option-filter-prop="children"
                v-decorator="[
                  'prospek',
                  {
                    rules: [{ required: (getTlc_CEO==end_user_klaim ? false : true) }],
                  },
                ]"
              >
                <a-select-option
                  v-for="item in listProspect"
                  :key="item.id_prospek"
                >
                  {{ item.no_prospek }} - {{ item.description }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-row :gutter="24" v-if="1==0 && informasi.type_activity">
              <a-col span="0" style="display:none">
                <a-form-item label="Activity Type">
                  <a-select placeholder="Please Select" 
                  disabled
                  v-decorator="[
                    'type_activity',
                    { rules: [{ required: true }], initialValue: informasi.type_activity },
                  ]"
                  class="width-full">
                    <a-select-option :key="informasi.type_activity">
                      {{informasi.type_activity}}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col span="24">
                <a-form-item label="Activity" v-if="1==0 && informasi.activity">
                  <a-select
                  v-decorator="[
                    'activity',
                    { rules: [{ required: true }], initialValue: informasi.activity },
                  ]" disabled class="width-full">
                    <a-select-option :key="informasi.activity">
                      {{informasi.activity}}
                    </a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item label="Pipeline" v-if="1==0 && informasi.selectedPipeline">
                  <a-select
                    disabled
                    v-decorator="[
                      'pipeline_id',
                      {
                        rules: [{ required: true }],
                        initialValue: informasi.selectedPipeline.pipeline_id,
                      },
                    ]"
                  >
                    <a-select-option :key="informasi.selectedPipeline.pipeline_id">
                      [{{ informasi.selectedPipeline.pipeline_no}}] {{ informasi.selectedPipeline.definitions }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>

            <a-form-item label="Credit">
              <a-input-number
                :min="0"
                @keydown="onlyNumber"
                class="m-width-full"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                v-decorator="[
                  'kredit',
                  { rules: [{ required: true }, { validator: checkPrice }] },
                ]"
              />
            </a-form-item>
            <a-form-item label="Expense Date">
              <a-date-picker
                placeholder="Select Date"
                :format="getDefaultDateFormat"
                v-decorator="[
                  'tanggal_pengeluaran',
                  { rules: [{ required: true }] },
                ]"
              />
            </a-form-item>

            <!-- <a-form-item label="End User">
              <a-select
                showSearch
                allowClear
                labelInValue
                :filter-option="filterOptionTlc"
                option-filter-prop="children"
                v-decorator="['end_user', { rules: [{ required: true }] }]"
                
              >
                <a-select-option v-for="user in getEndUserCCFiltered" :key="user.id_user_cc"
                  >{{ user.nama }} ({{user.type_cc}} / {{ formatRupiah(user.limit_kredit) }})</a-select-option
                >
              </a-select>
            </a-form-item> -->
          </a-col>
        </a-row>
        <a-row :gutter="12">
          <a-col :xs="{ span: 12 }" :lg="{ span: 12 }">
            <a-form-item label="Is Commission?">
              <a-radio-group
                v-decorator="[
                  'iscommision',
                  { rules: [{ required: false }], initialValue: '0' },
                ]"
                :disabled="EnCommission"
                button-style="solid"
                @change="handleOptionCommission"
              >
                <a-radio-button value="1"> Yes </a-radio-button>
                <a-radio-button value="0"> No </a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :xs="{ span: 12 }" :lg="{ span: 12 }">
            <!-- <a-form-item label="With Note?" :hidden="Viwithout_note"> -->
              <a-form-item label="With Note?" :hidden="true">
              <a-radio-group
                v-decorator="[
                  'without_note',
                  { rules: [{ required: false }], initialValue: '0' },
                ]"
                button-style="solid"
              >
                <a-radio-button value="0"> Yes </a-radio-button>
                <a-radio-button value="1"> No </a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item label="Upload Transaction Document">
          <a-upload
            :showUploadList="true"
            :fileList="doctransfiles"
            :beforeUpload="beforedoctransUpload"
            :remove="handledoctransRemove"
            v-decorator="['doctrans', { valuePropName: 'doctransfiles' }]"
          >
            <a-button>
              <a-icon type="upload" />&nbsp;Select File
            </a-button>
          </a-upload>
        </a-form-item>
      </a-form>
      <div >
        <a-divider class="margin-bottom-small">or</a-divider>
        <div>
          <h4>Upload Excel File</h4>
          <p>
            If You Don't Have a File Upload Template Please Click
            <a-button class="padding-remove" type="link" @click="handleDownload">Download Template</a-button>
          </p>
          <a-upload
            accept=".xls, .xlsx"
            :showUploadList="true"
            :fileList="push"
            :remove="handleRemove"
            :beforeUpload="beforeUpload"
            v-decorator="['upload', { valuePropName: 'push' }]"
          >
            <a-button>
              <a-icon type="upload" />&nbsp;Select File
            </a-button>
          </a-upload>
          <a-divider v-if="getScreen"></a-divider>
        </div>
      </div>
      <a-button v-if="getScreen" type="primary" block @click="handleNew" :loading="newLoading">Add</a-button>
    </a-col>
    <a-col :xs="{ span: 24 }" v-if="getScreen">
      <a-collapse class="margin-top">
        <a-collapse-panel key="1">
          <h4 slot="header" class="margin-remove">View Details</h4>
          <a-list itemLayout="vertical" :dataSource="dataList" :pagination="pagination">
            <Empty v-if="dataList ? dataList.length <= 0 : dataList" />
            <a-list-item slot="renderItem" slot-scope="item">
              <a-list-item-meta>
                <a-row slot="title" type="flex" justify="space-between">
                  <a href="#">{{ item.deskripsi }}</a>
                </a-row>
                <ul slot="description" class="m-list-wrapper">
                  <li class="margin-remove">
                    {{
                    moment(item.tanggal_pemakaian).format(
                    getDefaultDateFormat
                    )
                    }}
                  </li>
                  <li class="margin-remove">{{ item.alokasi }} | {{ item.proyek }}</li>

                  <li>
                    <h3 class="margin-remove">{{ formatRupiah(item.kredit) }}</h3>
                  </li>
                </ul>
              </a-list-item-meta>
              <a-button-group v-if="getScreen && item.kredit !== ''">
                <a-button type="primary" @click="handleEdit(item)">
                  <a-icon type="edit" />&nbsp;Edit
                </a-button>
                <a-button type="danger" @click="handleRemoveDetail(item)">
                  <a-icon type="close" />&nbsp;Remove
                </a-button>
              </a-button-group>
            </a-list-item>
          </a-list>
        </a-collapse-panel>
      </a-collapse>
      <div class="m-price-total">
        <!--  <h3 class="margin-remove m-text-align right" >Total : {{formatCurrency(mata_uang,totalPrice)}}</h3>
          <h3 class="margin-remove m-text-align right" >Tax ({{tax+'%'}}) : {{formatCurrency(mata_uang,nilaiPajak)}}</h3>
        <h3 class="margin-remove m-text-align right" v-if="check_shipping">Shipping Cost  : {{formatCurrency(mata_uang,shipping)}}</h3>-->
        <a-statistic
          title="Grand Total"
          :value="formatRupiah(this.kredit)"
          class="m-text-align right"
        />
      </div>
      <!--<div class="m-price-total" v-if="pageLoading === false">-->
      <!--<div class="m-display-flex space-between align-middle">-->
      <!--<h4>Total Kredit</h4>-->
      <!--<h3>{{formatRupiah(initialList.kredit)}}</h3>-->
      <!--</div>-->
      <!--</div>-->
      <a-checkbox :disabled="dataList.length < 1" @change="handleCheckData">Is Data Completed?</a-checkbox>
    </a-col>

<!--    <Modal-->
<!--      :data="modal.data"-->
<!--      :modalEdit="modal.modalEdit"-->
<!--      :confirmLoading="modal.confirmLoading"-->
<!--      :dataList="dataList"-->
<!--    />-->

    <a-modal
      v-model="modalanggaran.visible"
      v-if="modalanggaran.visible"
      title="Choice Financing Code"
      :footer="null"
      :width="700"
    >
      <a-tree-select
        v-model="modalanggaran.value"
        show-search
        style="width: 100%"
        @change="handlechoiceCost"
        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
        :tree-data="modalanggaran.tree"
        treeNodeFilterProp="children"
        :filterTreeNode="filterTreeNode"
        placeholder="Please select"
        allow-clear
        tree-default-expand-all
      >
        <span slot="title" slot-scope="item">
          <table style="width:100%">
            <tr>
              <td>
                <span>{{item.texttitle}} - {{item.kode_anggaran}}</span>
              </td>
              <td>
                <span style="float:right">{{formatRupiah(parseFloat(item.rekap))}}</span>
              </td>
            </tr>
          </table>
        </span>
      </a-tree-select>
    </a-modal>
    <a-modal
        title="Confirmation"
        :visible="confirm"
        @ok="handleconfirmOk"
        :confirmLoading="confirmLoading"
        @cancel="handleconfirmCancel"
        okText= "OK"
        cancelText= "Cancel"
        :maskClosable="false"
      >
        <p>The data that has been added will be overwritten with your new file? Are you sure?</p>
      </a-modal>
  </a-row>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
// import Modal from "../Modal.vue";
import Loading from "@/components/preloader/Loading.vue";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "PemakaianKlaimDirektur",
  components: {
    // Modal,
    Loading,
  },
  mixins: [CurrencyFormat,GlobalMethod],
  props: {
    data: {},
    informasi: {},
    mode: {},
    url: "",
    id_klaim: "",
    dataList: {},
    debit: 0,
    kredit: 0,
    mata_uang: "",
    type: "",
  },
  data() {
    return {
      push: [],
      confirm: false,
      confirmLoading: false,
      newLoading: false,
      pageLoading: true,
      pagination: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
      initialEdit: {},
      modal: {
        modalEdit: false,
        confirmLoading: false,
        confirm: false,
        data: {
          tanggal_pemakaian: moment().format(),
          deskripsi: "",
          kredit: "",
          id: "",
          type: "",
          alokasi: "",
          proyek: "",
        },
      },
      kategori: "",
      peruntukan: [],
      subPeruntukan: [],
      anggaran: {
        peruntukan_id: "",
        anggaran_id: "",
        id_klaim: "",
        modalvalue: undefined,
        path: "",
        limit: 0,
        tree: [],
        treeModal: [],
        searchValue: "",
        loadingtree: false,
      },
      modalanggaran: {
        visible: false,
        enabled: false,
        loadingButton: false,
        value: undefined,
        tree: {},
        searchValue: "",
      },
      costCenter: [],
      treeExpandedKeys: [],
      EnCommission: true,
      Viwithout_note: true,
      doctransfiles: [],
      selectedCostCenter: null,
      listProspect: [],
    };
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getScreen",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getAlokasi",
      "getCostCenter",
      "getPeruntukan",
      "getSubPeruntukan",
      "getAnggaran",
      "getJenisAnggaran",
      "getEndUserCC",
      "getTlc_CEO",
    ]),
    initialList() {
      if (this.dataList.length > 0) {
        let kredit = 0;
        let data = this.dataList;
        if (this.dataList.length > 1 || this.dataList !== undefined) {
          data.forEach((item) => {
            kredit = parseInt(kredit) + parseInt(item.kredit);
          });
        }

        return { kredit: kredit };
      } else {
        return { kredit: 0 };
      }
    },
    getEndUserCCFiltered(){
      return this.informasi.cost_center && this.informasi.cost_center.includes('MARDEV') ? 
        this.getEndUserCC.filter(item=>item.tlc=='ADI') : this.getEndUserCC
    },
    end_user_klaim(){
      return this.informasi ? this.informasi.tlc_id_user_cc : ''
    }
  },
  created() {
    this.$store.dispatch("FETCH_COST_CENTER_KD");
    this.$store.dispatch("FETCH_ENDUSER_CC");
    this.fetchPemakaian();
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.formEdit = this.$form.createForm(this);
  },
  methods: {
    moment,
    recountingAnggaran(arr) {
      arr = arr.filter((obj) => obj.path !== "");
      if (arr.length > 0) {
        //restore nominal ke origin
        arr.forEach((elm) => {
          if(elm.path){
            let ObjVal = elm.path.split(";");
            let path1 = "";
            let path2 = "";
            let path3 = "";
            let trigerpath = true;
            let tempTree = this.anggaran.tree;
            ObjVal.forEach((element) => {
              if (path1 == "") {
                path1 += "tempTree[" + element + "]";
                path3 = path1;
              } else {
                path3 = path1 + ".children";
                path1 += ".children[" + element + "]";
              }
              if (trigerpath) {
                if (!eval(path3)) {
                  trigerpath = false;
                  return;
                } else {
                  if (!eval(path1)) {
                    trigerpath = false;
                    return;
                  }
                }
              }
            });

            if (trigerpath) {
              path2 = eval(path1 + ".origin_rekap");
              eval(path1 + ".rekap=" + path2);
              //eval(path1+".disabled=false")
            }
          }
        });
        //menghitung nominal dengan acuan nominal origin
        arr.forEach((elem) => {
          if(elem.path){
            let ObjVal = elem.path.split(";");
            let path = "";
            let tpath = "";
            let trigerpath = true;
            let tempTree = this.anggaran.tree;
            ObjVal.forEach((element) => {
              if (path == "") {
                path += "tempTree[" + element + "]";
                tpath = path;
              } else {
                tpath = path + ".children";
                path += ".children[" + element + "]";
              }
              if (trigerpath) {
                if (!eval(tpath)) {
                  trigerpath = false;
                  return;
                } else {
                  if (!eval(path)) {
                    trigerpath = false;
                    return;
                  }
                }
              }
            });
            if (trigerpath) {
              let kd_anggrn = eval(path + ".kode_anggaran");
              if (kd_anggrn == elem.kode_anggaran) {
                let oldVal = eval(path + ".rekap");
                let num = oldVal - parseFloat(elem.kredit);
                let exe = path + ".rekap=" + num;
                eval(exe);
                if (num <= 0) {
                  eval(path + ".disabled=true");
                } else {
                  eval(path + ".disabled=false");
                }
              }
            }
            this.anggaran.tree = tempTree;
          }
        });
      }
    },
    async getTreeAnggaran() {
      this.anggaran.loadingtree = true;
      let dataParams =
        (this.mode == "Edit" && this.type == "revised") || (this.id_klaim && this.type == "draft")
          ? {
              anggaran_id: this.anggaran.anggaran_id,
              tlc: this.getAuth.username,
              peruntukan_id: this.anggaran.peruntukan_id,
              id_klaim: this.id_klaim,
            }
          : {
              anggaran_id: this.anggaran.anggaran_id,
              tlc: this.getAuth.username,
              peruntukan_id: this.anggaran.peruntukan_id,
            };
      if (dataParams.peruntukan_id) {
        await axios({
          method: "get",
          url: this.$serviceUrl + "klaim_cc/tree_anggaran",
          params: dataParams,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.anggaran.tree = response.data.tree;
            this.anggaran.treeModal = [
              ...this.anggaran.treeModal,
              response.data.tree[0],
            ];
            //let arr = this.dataList.filter((item) => item.kredit !== "");
            //this.recountingAnggaran(arr);

            this.treeExpandedKeys = this.getParent(response.data.tree);

            if(this.selectedCostCenter=='07'){
              this.getProspectList();
            }else{
              this.anggaran.loadingtree = false;
            }
          })
          .catch((err) => {
            this.anggaran.loadingtree = false;
            console.log(err);
            let responses = Object.assign({}, err.response);
            this.displayMessageValue("error", responses);
          });
      }
      this.anggaran.loadingtree = false;
    },
    // filterTreeNode(input, option) {
    //   return (
    //     option.data.props.texttitle==undefined || (option.data.props.texttitle ? option.data.props.texttitle : "").toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
    //     (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "").toLowerCase().indexOf(input.toLowerCase()) >= 0
    //   );
    // },
    handleCodeAnggarn(e) {
      let forms = this.form.getFieldsValue();
      this.modalanggaran.value =
        forms.peruntukan + ";" + forms.sub_peruntukan + ";" + e;
    },
    filterTreeNode(input, option) {
      //console.log(input, option)
      return (
        option.data.props.texttitle == undefined ||
        (option.data.props.texttitle ? option.data.props.texttitle : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0 ||
        (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handlechoiceCost(value, record) {
      // if (val){
      //   let kod = val.split(";")
      //   this.$nextTick(function () {
      //     this.handlePeruntukan(kod[0]);
      //     this.form.setFieldsValue({
      //         peruntukan: kod[0],
      //     });
      //     this.handleSubPeruntukan(kod[1]);
      //     this.form.setFieldsValue({
      //         sub_peruntukan: kod[1],
      //         kode_anggaran: kod[2]
      //     });
      //   });
      // }else{
      //   this.$nextTick(function () {
      //     this.form.setFieldsValue({
      //         peruntukan: undefined,
      //         sub_peruntukan: undefined,
      //         kode_anggaran: undefined
      //     });
      //   });
      // }
      this.anggaran.limit = record.dataRef.rekap;
      this.anggaran.path = record.dataRef.path;

      let isKomisi = this.getCommisionSts(this.anggaran.path);
      if(isKomisi){
        this.EnCommission = true;
        this.Viwithout_note = false;
        this.$nextTick(function () {
          this.form.setFieldsValue({
              iscommision: "1",
              without_note: "0",
          });
        });
      }else{
        this.EnCommission = false;
        this.Viwithout_note = true;
        this.$nextTick(function () {
          this.form.setFieldsValue({
              iscommision: "0",
              without_note: "0",
          });
        });
      }
      
      this.modalanggaran.visible = false;

    },
    getCommisionSts(val){
      let kdAnggrn = val.split(";");
      let text = "";
      for (let i = 0; i < (kdAnggrn.length-1); i++) {
        if (i==0){
          text="this.anggaran.tree[0]";
        }else{
          text = text+".children["+kdAnggrn[i]+"]";
        }
      }
      text = eval(text+".title");
      let sts = false;
      if(text.toLowerCase().includes("komisi"))
        sts = true;
      return sts;
    },
    showChoiceModal() {
      this.modalanggaran.visible = true;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleCost(e) {
      // this.modalanggaran.enabled = false;
      // this.modalanggaran.loadingButton = true;
      // axios({
      //   method: "get",
      //   url: this.$serviceUrl + "anggaran/tree_anggaran",
      //   params: {
      //     anggaran_id: e,
      //     tlc: this.getAuth.username,
      //   },
      //   auth: {
      //     username: this.getAuth.username,
      //     password: this.getAuth.password,
      //   },
      //   headers: {
      //     "X-API-KEY": this.getAuth.apikey,
      //   },
      // })
      //   .then((response) => {
      //     //console.log(response);
      //     this.modalanggaran.enabled = true;
      //     this.modalanggaran.loadingButton = false;
      //     this.modalanggaran.tree = response.data.tree;
      //   })
      //   .catch((err) => {
      //     let responses = Object.assign({}, err.response);
      //   });

      this.form.resetFields(["peruntukan", "sub_peruntukan", "kode_anggaran"]);
      this.subPeruntukan = [];
      this.anggaran.tree = [];
      this.anggaran.treeModal = [];
      const peruntukan = e ? this.getPeruntukan.filter(
        (obj) => obj.anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      ): [];
      this.peruntukan = peruntukan;

      this.anggaran.anggaran_id = e;
    },
    handlePeruntukan(e) {
      this.form.resetFields(["sub_peruntukan", "kode_anggaran"]);
      this.anggaran.peruntukan_id = e;
      this.anggaran.tree = [];
      this.anggaran.treeModal = [];
      const filter = e ? this.getSubPeruntukan.filter(
        (obj) => obj.peruntukan_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      ):[];
      this.subPeruntukan = filter;

      let selectedumDtl = _.filter(this.getSubPeruntukan, { peruntukan_id: e });
      if(selectedumDtl[0] && selectedumDtl[0].is_komisi){
        this.EnCommission = true;
        this.Viwithout_note = false;
        this.$nextTick(function () {
          this.form.setFieldsValue({
              iscommision: "1",
              without_note: "1",
          });
        });
      }else{
        this.EnCommission = false;
        this.Viwithout_note = true;
        this.$nextTick(function () {
          this.form.setFieldsValue({
              iscommision: "0",
              without_note: "1",
          });
        });
      }

      this.getTreeAnggaran();
    },
    handleSubPeruntukan(e) {
      this.form.resetFields(["kode_anggaran"]);
      const filter = this.getAnggaran.filter(
        (obj) => obj.anggaran_dtl_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );
      this.anggaran = filter;
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      let extension =
        file.name.substr(file.name.lastIndexOf(".")) == ".xls" ||
        file.name.substr(file.name.lastIndexOf(".")) == ".xlsx";
      if (extension) {
        if (FileSize > 2) {
          this.displayMessage("large-file-2mb");
        } else {
          this.push = [file];
          this.form.resetFields();
          return false;
        }
      } else {
        this.displayMessage("error-formatXls");
      }
    },
    done() {
      this.pageLoading = false;
    },
    fetchPemakaian() {
      this.pageLoading = true;
      Event.$emit("fetchPemakaian", true);
    },
    handleRemoveDetail(e) {
      if (this.mode == "Edit" && this.dataList.length == 2) {
        this.displayMessageValue(
          "error-other",
          "can not delete this data, because this transaction has at least 1 data!"
        );
      } else {
        Event.$emit("removeDetail", e);
      }
    },
    handleNew() {
      if (this.push.length>0) {
        this.handleNewProcess();
      }else{
        this.form.validateFields((err, values) => {
          if (err) {
            this.newLoading = false;
            this.pageLoading = false;
            this.displayMessage("form-warning");
            return;
          }

          if(moment(values.tanggal_pengeluaran).format('YYYY-MM-DD')>moment().format('YYYY-MM-DD')){
            this.newLoading = false;
            this.pageLoading = false;
            this.displayMessageValue("error-other", "Expense date can't exceed today!");
            return;
          }
          //antisipasi error bigint postgresql
          // if (this.dataList && this.dataList.length>0 && this.debit>0){
          //   let nom = this.kredit+parseFloat(values.pengeluaran_kas_kecil)
          //   if (this.debit<nom){
          //     this.displayMessageValue("error-other","The value max Petty Cash is "+this.formatRupiah(this.debit))
          //     return
          //   }else{
          //     this.confirmMessageValue("confirm-add-detil", true);
          //   }
          // }else{
          // this.confirmMessageValue("confirm-add-detil", true);
          //}
          this.handleNewProcess();
        });
      }
    },
    handleNewProcess() {
      let addData = new FormData();
      this.newLoading = true;
      Event.$emit("handleLoading", true);

      addData.append("tlc", this.getAuth.username);
      addData.append("id_klaim", this.id_klaim);
      // addData.append("no_sppd", this.informasi.no_sppd);
      addData.append(
        "tanggal_pelaporan",
        this.informasi.tanggal_pelaporan.format(this.getStandartFormatDate)
      );
      addData.append("approval_pic", this.informasi.pic);
      addData.append("approval_bod", this.informasi.bod);

      if (this.push.length > 0 && this.dataList.length > 0) {
        this.confirm = true;
      }else if (this.push.length > 0) {
        addData.append("iscommision", "0");
        addData.append("without_note", "1");
        this.push.forEach((file) => {
          addData.append("file_upload", file);
        });

        this.newLoading = true;
        this.pageLoading = true;

        this.postUpload(addData);
      } else {
        this.form.validateFields((err, values) => {
          if (err) {
            this.newLoading = false;
            this.pageLoading = false;
            Event.$emit("handleLoading", false);
            this.displayMessage("form-warning");
            return;
          }



          // if (parseFloat(this.anggaran.limit)<values.pengeluaran_kas_kecil){
          //   this.displayMessageValue("limit-anggaran",this.formatRupiah(this.anggaran.limit))
          //   return
          // }else{
          addData.append(
            "tanggal_pengeluaran",
            values.tanggal_pengeluaran.format(this.getStandartFormatDate)
          );
          addData.append("kredit", values.kredit);
          addData.append("deskripsi", values.deskripsi ? values.deskripsi : "");
          //addData.append("allocation", values.alokasi);
          //addData.append("project", values.proyek);
          let kd = values.kode_anggaran.split(";");
          addData.append("kode_anggaran", kd[kd.length - 1]);
          addData.append("sub_peruntukan", kd[kd.length - 2]);
          addData.append("peruntukan", values.peruntukan);
          addData.append("cost_center", values.cost_center);
          addData.append("anggaran_dtl_val_id", kd[kd.length - 1]);
          addData.append("jenis_anggaran", values.jenis_anggaran);
          addData.append("path", this.anggaran.path);
          // addData.append("id_user_cc", values.end_user.key);
          addData.append("id_user_cc",this.informasi.id_user_cc);
          addData.append("iscommision", values.iscommision);
          // addData.append("without_note", values.without_note);
          addData.append("without_note", "1");
          if(values.type_activity){
            addData.append("activity_type", values.type_activity);
            if(values.activity) addData.append("activity", values.activity);
            if(values.pipeline_id) addData.append("pipeline", values.pipeline_id);
          }

          if (this.doctransfiles && this.doctransfiles.length > 0) {
            this.doctransfiles.forEach((file) => {
              addData.append("file_upload", file);
            });
          }

          if(values.prospek){
            addData.append("prospek", values.prospek);
          }

          this.newLoading = true;

          axios({
            method: "post",
            url: this.url,
            processData: false,
            data: addData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "multipart/form-data",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success-add");
              this.fetchPemakaian();
              this.newLoading = false;
              this.pageLoading = false;
              this.form.resetFields();
              this.$nextTick(function () {
                this.form.setFieldsValue({
                  jenis_anggaran: this.informasi.jenis_anggaran,
                  cost_center: this.informasi.cost_center,
                  peruntukan: this.informasi.peruntukan,
                });
              });
              // this.getTreeAnggaran();
              if (this.mode === "Create") {
                Event.$emit("disableInformasi", true);
              }

              // this.costCenter = [];
              // this.peruntukan = [];
              this.subPeruntukan = [];
              // this.anggaran.tree = [];
              // this.anggaran.treeModal = [];
              this.modalanggaran.value = null;
              this.doctransfiles = [];
            })
            .catch((err) => {
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error-other", responses.message);
              console.log("error : " + err);
              Event.$emit("handleLoading", false);
            });
          // }
        });
      }
    },
    postUpload(data) {
      let url =
        this.type === "revised"
          ? "klaim_cc/revisi_upload_detil_pemakaian"
          : "klaim_cc/upload_detil_pemakaian";
      axios({
        method: "post",
        url: this.$serviceUrl + url,
        processData: false,
        data: data,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "multipart/form-data",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          if (response.data.message=='Upload Success'){
            if (this.mode === "Create") {
              this.push = [];
              this.displayMessage("success-add");
              this.fetchPemakaian();
              this.newLoading = false;
              this.pageLoading = false;
              this.confirm = false;
              Event.$emit("disableInformasi", true);
            } else {
              this.push = [];
              this.displayMessage("success-edit");
              this.fetchPemakaian();
              this.newLoading = false;
              this.pageLoading = false;
              this.confirm = false;
              Event.$emit("disableInformasi", true);
            }
          }else{
            this.displayMessageValue(
              "error-other",
              response.data.message
            );
            this.newLoading = false;
            this.pageLoading = false;
            this.confirm = false;
            Event.$emit("disableInformasi", true);
          }
          this.push = [];
          this.confirmLoading = false;
          Event.$emit("handleLoading", false);
        })
        .catch((err) => {
          console.log(err);
          this.confirmLoading = false;
          Event.$emit("handleLoading", false);
        });
    },
    handleCheckData(e) {
      Event.$emit("draftStatus", e.target.checked);
    },
    handleEdit(item) {
      this.modal.data = {
        path: item.path,
        tanggal_pemakaian: item.tanggal_pemakaian,
        deskripsi: item.deskripsi,
        kredit: item.kredit,
        id: item.id,
        type: this.type,
        proyek: item.proyek,
        alokasi: item.alokasi,
        jns_anggaran_id: item.jns_anggaran_id,
        anggaran_code: item.kode_anggaran_id=="null;null;null"? undefined : item.kode_anggaran_id,
      };
      this.modal.modalEdit = true;
      this.modal.type = this.type;
    },
    handleDownload() {
      axios({
        method: "get",
        url: this.$serviceUrl + "/main/download_template_klaim_cc",
        params: {
          id_lk: this.id,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          window.open(this.$serviceUrl + response.data.url, "_blank");
        })
        .catch((err) => {
          this.displayMessage("error-emptyDocTemplate");
        });
    },
    handleCancel(e) {
      this.confirm = false;
      this.modal.modalEdit = false;
    },
    checkPrice(rule, value, callback) {
      if (value > 0) {
        callback();
        return;
      }
      callback("Price must greater than zero!");
    },
    handleProyek(value) {
      let filter = this.project.filter(
        (obj) =>
          obj.kode_project.toLowerCase().indexOf(value.toLowerCase()) >= 0
      );

      this.kategori = filter[0].kategori;
      this.form.setFieldsValue({
        alokasi: "",
      });
    },
    handleJenisAnggaran(e) {
      this.selectedCostCenter = e
      this.listProspect = []
      this.form.resetFields([
        "cost_center",
        "peruntukan",
        "sub_peruntukan",
        "kode_anggaran",
      ]);
      const filter = e ? this.getCostCenter.filter(
        (obj) => obj.jns_anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      ) : [];

      this.modalanggaran.enabled = false;
      this.costCenter = filter;
      this.subPeruntukan = [];
      this.peruntukan = [];
      this.anggaran.tree = [];
      this.anggaran.treeModal = [];
    },
    resetFormPemakaian(spesificScopes) {
      this.form.resetFields();
      this.costCenter = [];
      this.peruntukan = [];
      if(spesificScopes)
        this.anggaran.tree = [];
      this.getTreeAnggaran();
    },
    getParent(root) {
      let data = [];
      root.forEach((item) => {
        if (item.key) {
          data.push(item.key);
        }

        if (item.children.length > 0) {
          item.children.forEach((d) => {
            data.push(d.key);
          });
        }
      });
      return data;
    },
    handleconfirmOk() {
      Event.$emit("handleLoading", true);
      this.ModalText = "The modal will be closed after two seconds";
      this.confirmLoading = true;

      let addData = new FormData();

      addData.append("tlc", this.getAuth.username);
      addData.append("id_klaim", this.id_klaim);
      addData.append(
        "tanggal_pelaporan",
        this.informasi.tanggal_pelaporan.format(this.getStandartFormatDate)
      );
      addData.append("approval_pic", this.informasi.pic);
      addData.append("approval_bod", this.informasi.bod);
      this.push.forEach((file) => {
          addData.append("file_upload", file);
        });

      this.postUpload(addData);
    },
    handleconfirmCancel() {
      this.confirm = false;
      //this.modal.modalEdit = false;
    },
    handleRemove(){
      this.push = [];
    },
    filterOptionTlc(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleOptionCommission(val){
      if(val.target.value=="1"){
        this.Viwithout_note = false;
      }else{
        this.Viwithout_note = true;
      }
      this.$nextTick(function () {
          this.form.setFieldsValue({
              without_note: "0",
          });
        });
    },
    beforedoctransUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.doctransfiles = [file];
        return false;
      }
    },
    handledoctransRemove() {
      this.doctransfiles = [];
    },
    async getProspectList(){
      await axios({
        method: "get",
        url: this.$serviceUrl + "prospek/pilih_prospek",
        params: {
          anggaran_id: this.anggaran.anggaran_id
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
      .then(async (response) => {
        this.listProspect = response.data.data ? response.data.data : [];
        this.anggaran.loadingtree = false;
      })
      .catch(() => {
      });
    }
  },
  mounted() {
    Event.$on("modalCancel", this.handleCancel);
    Event.$on("confirmMessageAddDetil", this.handleNewProcess);
    Event.$on("resetdtlpemakaian", this.resetFormPemakaian);

    if(this.informasi){
      this.handleJenisAnggaran(this.informasi.jenis_anggaran)
      this.handleCost(this.informasi.cost_center)
      this.handlePeruntukan(this.informasi.peruntukan)
    }
  },
  beforeDestroy() {
    Event.$off("modalCancel", this.handleCancel);
    Event.$off("confirmMessageAddDetil", this.handleNewProcess);
    Event.$off("resetdtlpemakaian", this.resetFormPemakaian);
  },
  watch: {
    "anggaran.loadingtree"(){
      Event.$emit("triggerActionBtnKlaimCC", this.anggaran.loadingtree);
    },
  }
};
</script>

<style lang="less">
.ant-select-selection-selected-value {
  width: 100%;
}

.ant-input-number-input{
    text-align: right;
    padding-right: 25px;
  }
</style>